export default __webpack_public_path__ + "locales/uk-UA/FilesSettings.json?hash=415a9abb62b93421c6b1a63fdfae8f09";